import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './PricingSection.css';


const PricingSectionForHome = () => {

  const [pricing, setPricing] = useState([]);


  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/pricings`)
      .then((res) => res.json())
      .then((info) => setPricing(info));
  }, []);

  return (


    <><section className="price-section" id='pricing-sec'>
      <div className="container">
        <figure className="mb-0 price-circle">
          <img className="img-fluid" src="./assets/images/price-circle.png" alt />
        </figure>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="price_heading">
              <h4 className='heading-color'>What We Offer</h4>
              <h2>Choose Your Pricing Plan</h2>
            </div>
          </div>
        </div>
        <div className="price-block">
          <div className="row" data-aos="fade-up">
            <figure className="mb-0 price-sidecircle">
              <img className="img-fluid" src="./assets/images/price-sidecircle.png" alt />
            </figure>
            {
              pricing.map(b => b.pageSlug === '' && <div className="col-lg-4 col-md-4 col-sm-6 col-12 mb-md-0 mb-4">
                <div className="price_content hover1">
                  <div className="icon-size1">
                    <figure className="mb-0 price-basicicon">
                      <img src="./assets/images/price-basicicon.png" alt className="img-fluid" />
                    </figure>
                  </div>
                  <h5 className="mb-0">{b.packageName} Plan</h5>
                  <span className="text1">${b.packagePrice}</span>
                  <ul className="list-unstyled mb-0">
                    <li className="text-size-18">{b.packagePointOne}</li>
                    <li className="text-size-18">{b.packagePointTwo}</li>
                    <li className="text-size-18">{b.packagePointThree}</li>
                    <li className="text-size-18">{b.packagePointFour}</li>
                    <li className="text-size-18">{b.packagePointFive}</li>
                    <li className="text-size-18">{b.packagePointSix}</li>
                  </ul>
                  <div className="price-button">
                    <Link to={`/order-now/${b._id}`} className="get_started basic">  <span>{b.packageButtonText}</span> </Link>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default PricingSectionForHome;